module.exports = __webpack_public_path__ + "static/media/iconAgrupamentoBlue.a4fb821f.svg";